import React from "react";
import { Navigate } from "react-router-dom";
import ClientPortalGuard from "src/components/guard/ClientPortalGuard";
import LogoutClient from "src/components/LogoutClient";
import ClientPortalBaseLayout from "src/layout/menu/client-portal";

const ClientPortalGuardedRoutes = [
  {
    exact: true,
    guard: ClientPortalGuard,
    layout: ClientPortalBaseLayout,
    path: "/",
    component: () => <Navigate to="/client/appointments" />,
    show: false,
  },

  {
    exact: true,
    guard: ClientPortalGuard,
    layout: ClientPortalBaseLayout,
    path: "/client/appointments",
    component: React.lazy(() =>
      import("src/views/clients-portal/appointments")
    ),
    name: "client_portal.navbar.appointments",
    show: true,
  },

  {
    exact: true,
    guard: ClientPortalGuard,
    layout: ClientPortalBaseLayout,
    path: "/client/events",
    component: React.lazy(() => import("src/views/clients-portal/events")),
    name: "Calendar Events",
    show: true,
  },

  {
    exact: true,
    guard: ClientPortalGuard,
    layout: ClientPortalBaseLayout,
    path: "/client/packages",
    component: React.lazy(() => import("src/views/clients-portal/packages")),
    name: "client_portal.navbar.packages",
    show: false,
  },

  {
    exact: true,
    guard: ClientPortalGuard,
    layout: ClientPortalBaseLayout,
    path: "/client/digital-products",
    component: React.lazy(() =>
      import("src/views/clients-portal/digital-products")
    ),
    name: "client_portal.navbar.digital_products",
    show: true,
  },

  {
    exact: true,
    guard: ClientPortalGuard,
    layout: ClientPortalBaseLayout,
    path: "/client/digital-products/details/:packageId",
    component: React.lazy(() =>
      import("src/views/clients-portal/digital-products/details")
    ),
    name: "Digital Products",
    show: false,
  },

  {
    exact: true,
    guard: ClientPortalGuard,
    layout: ClientPortalBaseLayout,
    path: "/client/courses",
    component: React.lazy(() => import("src/views/clients-portal/courses")),
    name: "client_portal.navbar.courses",
    show: true,
  },

  {
    exact: true,
    guard: ClientPortalGuard,
    layout: ClientPortalBaseLayout,
    path: "/client/packages/details/:type/:packageId",
    component: React.lazy(() =>
      import("src/views/clients-portal/packages/details")
    ),
    name: "Packages Details",
    show: false,
  },
  {
    exact: true,
    guard: ClientPortalGuard,
    layout: ClientPortalBaseLayout,
    path: "/client/courses/details/:packageId",
    component: React.lazy(() =>
      import("src/views/clients-portal/courses/details")
    ),
    name: "Courses Details",
    show: false,
  },

  {
    exact: true,
    guard: ClientPortalGuard,
    layout: ClientPortalBaseLayout,
    path: "/client/contents",
    component: React.lazy(() => import("src/views/clients-portal/contents")),
    name: "client_portal.navbar.content",
    show: true,
  },

  {
    exact: true,
    guard: ClientPortalGuard,
    layout: ClientPortalBaseLayout,
    path: "/client/surveys",
    component: React.lazy(() => import("src/views/clients-portal/surveys")),
    name: "client_portal.navbar.surveys",
    show: true,
  },

  {
    exact: true,
    guard: ClientPortalGuard,
    layout: ClientPortalBaseLayout,
    path: "/client/settings",
    component: React.lazy(() =>
      import("src/views/clients-portal/settings/account")
    ),
  },

  {
    exact: true,
    guard: ClientPortalGuard,
    layout: ClientPortalBaseLayout,
    path: "/client/notes",
    component: React.lazy(() => import("src/views/clients-portal/notes")),
    name: "Notes",
    show: true,
  },

  {
    exact: true,
    guard: ClientPortalGuard,
    layout: ClientPortalBaseLayout,
    path: "/client/tasks-goals",
    component: React.lazy(() => import("src/views/clients-portal/tasks_goals")),
    name: "Tasks & Goals",
    show: true,
  },

  {
    exact: true,
    guard: ClientPortalGuard,
    layout: ClientPortalBaseLayout,
    path: "/client/subscriptions",
    component: React.lazy(() =>
      import("src/views/clients-portal/subscriptions")
    ),
    name: "Subscriptions",
    show: false,
  },

  {
    exact: true,
    guard: ClientPortalGuard,
    layout: ClientPortalBaseLayout,
    path: "/client/logout",
    component: () => <LogoutClient />,
  },

  {
    exact: true,
    guard: ClientPortalGuard,
    layout: ClientPortalBaseLayout,
    path: "/client/notifications",
    component: React.lazy(() =>
      import("src/views/clients-portal/notifications")
    ),
  },
];

export default ClientPortalGuardedRoutes;
